/**
 * Entry Popup Script
 * Handles display logic, cookie management, and promo code copying
 */

(function() {
  'use strict';

  class EntryPopup {
    constructor() {
      console.log('EntryPopup: Initializing...');
      
      this.section = document.querySelector('[data-section-type="entry-popup"]');
      if (!this.section) {
        console.log('EntryPopup: Section not found');
        return;
      }

      this.modal = document.getElementById('entry-popup');
      if (!this.modal) {
        console.log('EntryPopup: Modal element not found');
        return;
      }

      this.overlay = this.modal.querySelector('.modal-overlay');
      this.closeButtons = this.modal.querySelectorAll('[data-micromodal-close]');
      this.copyButton = this.modal.querySelector('.promo-copy-btn');
      
      // Get settings from data attributes
      this.delay = parseInt(this.section.dataset.delay) || 3;
      this.days = parseInt(this.section.dataset.days) || 7;
      this.showOn = this.section.dataset.showOn || 'first_visit';
      
      this.cookieName = 'entry_popup_shown';
      
      console.log('EntryPopup: Settings loaded', {
        delay: this.delay,
        days: this.days,
        showOn: this.showOn
      });
      
      this.init();
    }

    init() {
      console.log('EntryPopup: Checking if should show...');
      
      // Setup event listeners first
      this.setupEventListeners();
      
      // Check if popup should be shown
      if (this.shouldShowPopup()) {
        console.log('EntryPopup: Scheduling popup for ' + this.delay + ' seconds');
        this.schedulePopup();
      } else {
        console.log('EntryPopup: Not showing popup (cookie exists or conditions not met)');
      }
    }

    shouldShowPopup() {
      // Check cookie
      const cookieExists = this.getCookie(this.cookieName);
      console.log('EntryPopup: Cookie check - ' + this.cookieName + ':', cookieExists);
      
      if (cookieExists) {
        return false;
      }

      // Check page condition
      if (this.showOn === 'homepage') {
        const isHomepage = window.location.pathname === '/' || window.location.pathname === '/index';
        console.log('EntryPopup: Homepage check:', isHomepage);
        return isHomepage;
      }

      if (this.showOn === 'first_visit') {
        const firstVisit = !this.getCookie('visited_before');
        console.log('EntryPopup: First visit check:', firstVisit);
        if (firstVisit) {
          this.setCookie('visited_before', 'true', 365); // Set visited cookie for 1 year
        }
        return firstVisit;
      }

      // 'all' pages
      console.log('EntryPopup: Show on all pages');
      return true;
    }

    schedulePopup() {
      setTimeout(() => {
        console.log('EntryPopup: Showing popup now');
        this.showPopup();
      }, this.delay * 1000);
    }

    showPopup() {
      console.log('EntryPopup: showPopup() called');
      
      if (!this.modal) {
        console.error('EntryPopup: Modal element not found!');
        return;
      }
      
      // Force display
      this.modal.style.display = 'block';
      this.modal.style.visibility = 'visible';
      this.modal.style.opacity = '1';
      this.modal.setAttribute('aria-hidden', 'false');
      
      // Prevent body scroll
      document.body.style.overflow = 'hidden';
      
      console.log('EntryPopup: Modal should be visible now');
      
      // Focus on modal for accessibility
      setTimeout(() => {
        const container = this.modal.querySelector('.modal-container');
        if (container) {
          container.setAttribute('tabindex', '-1');
          container.focus();
        }
      }, 100);
      
      // Track that popup was shown
      this.trackPopupShown();
    }

    hidePopup() {
      console.log('EntryPopup: Hiding popup');
      
      this.modal.style.display = 'none';
      this.modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      
      // Set cookie to not show again for X days
      this.setCookie(this.cookieName, 'true', this.days);
      console.log('EntryPopup: Cookie set for ' + this.days + ' days');
    }

    setupEventListeners() {
      console.log('EntryPopup: Setting up event listeners');
      
      // Close button clicks
      this.closeButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          console.log('EntryPopup: Close button clicked');
          this.hidePopup();
        });
      });

      // Removed: Click outside modal to close - users must click X button

      // Escape key to close
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.modal.getAttribute('aria-hidden') === 'false') {
          console.log('EntryPopup: Escape key pressed');
          this.hidePopup();
        }
      });

      // Copy promo code functionality
      if (this.copyButton) {
        this.copyButton.addEventListener('click', () => {
          console.log('EntryPopup: Copy button clicked');
          this.copyPromoCode();
        });
      }
    }

    copyPromoCode() {
      const code = this.copyButton.dataset.code;
      const copyText = this.copyButton.querySelector('.copy-text');
      const copiedText = this.copyButton.querySelector('.copied-text');

      console.log('EntryPopup: Copying code:', code);

      // Copy to clipboard
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(() => {
          this.showCopiedState(copyText, copiedText);
        }).catch(() => {
          // Fallback for older browsers
          this.fallbackCopy(code);
          this.showCopiedState(copyText, copiedText);
        });
      } else {
        // Fallback for older browsers
        this.fallbackCopy(code);
        this.showCopiedState(copyText, copiedText);
      }
    }

    fallbackCopy(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      document.body.appendChild(textArea);
      textArea.select();
      
      try {
        document.execCommand('copy');
        console.log('EntryPopup: Code copied (fallback method)');
      } catch (err) {
        console.error('EntryPopup: Failed to copy text:', err);
      }
      
      document.body.removeChild(textArea);
    }

    showCopiedState(copyText, copiedText) {
      // Show "Copied!" message
      if (copyText) copyText.style.display = 'none';
      if (copiedText) copiedText.style.display = 'inline';
      this.copyButton.classList.add('copied');

      // Reset after 2 seconds
      setTimeout(() => {
        if (copyText) copyText.style.display = 'inline';
        if (copiedText) copiedText.style.display = 'none';
        this.copyButton.classList.remove('copied');
      }, 2000);
    }

    trackPopupShown() {
      console.log('EntryPopup: Tracking popup shown');
      
      // Optional: Send analytics event
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'popup_shown', {
          event_category: 'engagement',
          event_label: 'entry_popup'
        });
      }
    }

    // Cookie helper functions
    setCookie(name, value, days) {
      let expires = '';
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toUTCString();
      }
      document.cookie = name + '=' + (value || '') + expires + '; path=/';
      console.log('EntryPopup: Cookie set:', name, '=', value, 'expires in', days, 'days');
    }

    getCookie(name) {
      const nameEQ = name + '=';
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) {
          const value = c.substring(nameEQ.length, c.length);
          console.log('EntryPopup: Cookie found:', name, '=', value);
          return value;
        }
      }
      console.log('EntryPopup: Cookie not found:', name);
      return null;
    }
  }

  // Initialize when DOM is ready
  function initPopup() {
    console.log('EntryPopup: DOM ready, initializing...');
    new EntryPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPopup);
  } else {
    initPopup();
  }

  // Also add a window load listener as backup
  window.addEventListener('load', function() {
    console.log('EntryPopup: Window loaded');
  });

})();
